import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { ApiResponse, TabData } from '@shared';
import { IPaginationParams } from '../interfaces/IPaginationParamas';

@Injectable({
  providedIn: 'root',
})
export class ApplicationUsersService {
  private tabCounts = signal<TabData>({
    invoice: 0,
    businessCards: 'No',
    buymeorder: 0,
    nirlatgiftorders: 0,
    priceoffers: 0,
    post: 0,
    favoritebusinesses: 0,
    points: 0,
    nirlatPromotions: 0,
    supplierGiftOrderCount: 0,
  });
  constructor(private http: HttpClient) {}
  getAllUsers(params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/users', { params: httpParams });
  }
  deleteUser(id: string) {
    return this.http.delete<ApiResponse>(`/v1/admin/users/${id}`);
  }
  getUserById(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/users/${id}`);
  }
  updateUser(id: string, userFormData: any) {
    return this.http.put<ApiResponse>(`/v1/admin/users/${id}`, userFormData);
  }

  getTabCountByUserId(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/users/tab-count/${id}`);
  }

  getFavouriteBusinesses(params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>(`/v1/admin/business`, { params: httpParams });
  }

  deleteFavouriteBusiness(userId: string, businessId: string) {
    return this.http.post<ApiResponse>(`/v1/admin/business/favourite-business`, {
      userId: userId,
      businessId: businessId,
    });
  }

  getPointsReport(id: string, params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>(`/v1/admin/points-report/user/${id}`, { params: httpParams });
  }

  exportUserList(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/users/export-users`, filterData, options);
  }

  exportPointsList(id: string, filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/points-report/export/${id}`, filterData, options);
  }

  getCityList() {
    return this.http.get<ApiResponse>('/v1/admin/users/city-drop-down-list');
  }

  setTabCounts(data: TabData) {
    this.tabCounts.set(data);
  }

  getTabCounts() {
    return this.tabCounts();
  }
}
